import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Emitter from '../alphabetbubble/Emitter';
import PopBubble from '../alphabetbubble/PopBubble';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    constructor()
    {
        super({ key: (Intro).KEY });
    }

    init()
    {
        this.titleSprite = null;
        this.inputField = null;
        this.points = [];
        this.santa = null;
        this.title = null;

        this.boxes = [];
        this.bodies = [];
        this.world = null;
        this.currentNumberQueue = [];
        this.bubbles = [];
        this.currentNumberToPop = 0;

        // reset shortest bonus time
        gameData.BEST_BONUS_TIME = 99999;

        this.box2d = (function ()
        {
            // important box2d scale and speed vars
            let SCALE = 30, STEP = 20, TIMESTEP = 1 / STEP;

            let world;
            let lastTimestamp = Date.now();
            let fixedTimestepAccumulator = 0;
            let bodiesToRemove = [];
            let actors = [];
            let bodies = [];

            // box2d world setup and boundaries
            let setup = function (scene)
            {
                world = new Box2D.Dynamics.b2World(new Box2D.Common.Math.b2Vec2(0, 0.0), true);

                // boundaries - top
                let topFixture = new Box2D.Dynamics.b2FixtureDef;
                topFixture.density = 1;
                topFixture.restitution = 0.1;
                topFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                topFixture.shape.SetAsBox((scene.scale.width) / SCALE, 10 / SCALE);
                let topBodyDef = new Box2D.Dynamics.b2BodyDef;
                topBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                topBodyDef.position.x = 0 / SCALE;
                topBodyDef.position.y = -60 / SCALE;
                let top = world.CreateBody(topBodyDef);
                top.CreateFixture(topFixture);

                // boundaries - floor
                let floorFixture = new Box2D.Dynamics.b2FixtureDef;
                floorFixture.density = 1;
                floorFixture.restitution = 0.1;
                floorFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                floorFixture.shape.SetAsBox((scene.scale.width) / SCALE, 10 / SCALE);
                let floorBodyDef = new Box2D.Dynamics.b2BodyDef;
                floorBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                floorBodyDef.position.x = -25 / SCALE;
                floorBodyDef.position.y = (scene.scale.height - 40) / SCALE;
                let floor = world.CreateBody(floorBodyDef);
                floor.CreateFixture(floorFixture);

                // boundaries - left
                let leftFixture = new Box2D.Dynamics.b2FixtureDef;
                leftFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                leftFixture.shape.SetAsBox(20 / SCALE, (scene.scale.width) / SCALE);
                let leftBodyDef = new Box2D.Dynamics.b2BodyDef;
                leftBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                leftBodyDef.position.x = -70 / SCALE;
                leftBodyDef.position.y = -25 / SCALE;
                let left = world.CreateBody(leftBodyDef);
                left.CreateFixture(leftFixture);

                // boundaries - right
                let rightFixture = new Box2D.Dynamics.b2FixtureDef;
                rightFixture.shape = new Box2D.Collision.Shapes.b2PolygonShape;
                rightFixture.shape.SetAsBox(20 / SCALE, (scene.scale.height) / SCALE);
                let rightBodyDef = new Box2D.Dynamics.b2BodyDef;
                rightBodyDef.type = Box2D.Dynamics.b2Body.b2_staticBody;
                rightBodyDef.position.x = (scene.scale.width - 30) / SCALE;
                rightBodyDef.position.y = -25 / SCALE;
                var right = world.CreateBody(rightBodyDef);
                right.CreateFixture(rightFixture);
            }

            // actor object - this is responsible for taking the body's position and translating it to your easel display object
            let actorObject = function (body, skin)
            {
                this.body = body;
                this.skin = skin;
                this.update = function ()
                {
                    // translate box2d positions to pixels
                    this.skin.x = this.body.GetWorldCenter().x * SCALE;
                    this.skin.y = this.body.GetWorldCenter().y * SCALE;
                }
                actors.push(this);
            }

            // create bird body shape and assign actor object
            let createCoin = function (skin)
            {
                let fixture = new Box2D.Dynamics.b2FixtureDef;
                fixture.density = 1;
                fixture.restitution = 0.6;
                fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(24 / SCALE);
                let bodyDef = new Box2D.Dynamics.b2BodyDef;
                bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;
                bodyDef.position.x = skin.x / SCALE;
                bodyDef.position.y = skin.y / SCALE;
                let coin = world.CreateBody(bodyDef);
                coin.CreateFixture(fixture);

                // assign actor
                var actor = new actorObject(coin, skin);
                coin.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(coin);
            }

            // remove actor and it's skin object
            let removeActor = function (actor)
            {
                if (actor.skin != null)
                {
                    if (actor.skin.scene != null)
                    {
                        actor.skin.destroy();
                    }
                }
                actors.splice(actors.indexOf(actor), 1);
            }

            // fixture and bodyDef defined in skin object
            let createBody = function (skin)
            {
                skin.bodyDef.position.x = skin.x / SCALE;
                skin.bodyDef.position.y = skin.y / SCALE;

                let body = world.CreateBody(skin.bodyDef);
                body.CreateFixture(skin.fixture);

                // assign actor
                let actor = new actorObject(body, skin);
                body.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(body);

                skin.body = body;
                // Phaser requires the body to have a destroy function... so add an empty one
                body.destroy = () => { };

                return body;
            };

            // box2d update function. delta time is used to avoid differences in simulation if frame rate drops
            let update = function ()
            {
                let now = Date.now();
                let dt = now - lastTimestamp;
                fixedTimestepAccumulator += dt;
                lastTimestamp = now;
                while (fixedTimestepAccumulator >= STEP)
                {
                    // remove bodies before world timestep
                    for (var i = 0, l = bodiesToRemove.length; i < l; i++)
                    {
                        removeActor(bodiesToRemove[i].GetUserData());
                        bodiesToRemove[i].SetUserData(null);
                        world.DestroyBody(bodiesToRemove[i]);
                    }
                    bodiesToRemove = [];

                    // update active actors
                    for (var i = 0, l = actors.length; i < l; i++)
                    {
                        actors[i].update();
                    }

                    world.Step(TIMESTEP, 10, 10);

                    fixedTimestepAccumulator -= STEP;
                    world.ClearForces();
                }
            }

            // create coin body shape and assign actor object
            let createBubble = function (skin)
            {
                let fixture = new Box2D.Dynamics.b2FixtureDef;
                fixture.density = 1;
                fixture.restitution = 0.6;
                fixture.shape = new Box2D.Collision.Shapes.b2CircleShape(24 / SCALE);
                let bodyDef = new Box2D.Dynamics.b2BodyDef;
                bodyDef.type = Box2D.Dynamics.b2Body.b2_dynamicBody;

                bodyDef.position.x = skin.x / SCALE;
                bodyDef.position.y = skin.y / SCALE;
                let coin = world.CreateBody(bodyDef);
                coin.CreateFixture(fixture);

                // assign actor
                var actor = new actorObject(coin, skin);
                coin.SetUserData(actor);  // set the actor as user data of the body so we can use it later: body.GetUserData()
                bodies.push(coin);
            };

            let pauseResume = function (p)
            {
                if (p)
                {
                    TIMESTEP = 0;
                }
                else { TIMESTEP = 1 / STEP; }
                lastTimestamp = Date.now();
            }

            return {
                setup: setup,
                update: update,
                createCoin: createCoin,
                createBody: createBody,
                createBubble: createBubble,
                pauseResume: pauseResume
            }
        })();
    }

    create()
    {
        let width = this.scale.width;
        let height = this.scale.height;
        this.points = [];

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._intro_background, this).setOrigin(0);

        this.addFish();
        this.addRays();

        this.title = ABCyaPhaser.Images.addImage(width / 2 - 1000, height / 2 - 80, UIAssetKeys._title_photo, this);
        ABCyaPhaser.Tweens.addTween(this.title, 600, { scaleX: 1.4, scaleY: 0.7, yoyo: true, repeat: 1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(this.title, 2400, { x: this.title.x + 1000 }, Phaser.Math.Easing.Linear, () => this.oscillate(this.title));

        this.button = ABCyaPhaser.Buttons.addSimpleButton(width / 2, height / 2 + 205, "go_button", null, this.goClicked.bind(this), this, { textureAtlas: "piecesData2" }).setScale(1.2);
        ABCyaPhaser.Tweens.addTween(this.button, 500, { delay: 100, scale: 1.7, yoyo: true }, Phaser.Math.Easing.Bounce.Out, () => this.float(this.button));

        ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._title, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        this.soundLoop = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle, this.soundLoop, 1, true);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.soundLoop.destroy());

        // physics for bubbles
        this.box2d.setup(this);
        this.events.on(Phaser.Scenes.Events.PRE_UPDATE, this.handleTick, this);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.events.off(Phaser.Scenes.Events.PRE_UPDATE, this.handleTick, this));

        this.makeBubbleNumbers();
    }

    addFish()
    {
        this.doFishMotion("fish1", -200, 300, 7400);
        this.doFishMotion("fish2", 1500, 100, 9400);
        this.doFishMotion("fish3", 1500, 200, 5400);
        this.doFishMotion("fish4", 1500, 400, 11400);
    }

    doFishMotion(spriteName, startX, startY, time)
    {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this, "piecesData2");

        let endX = -200;
        if (startX < 0)
        {
            endX = 1500;
        }

        ABCyaPhaser.Tweens.addTween(sprite, time, { x: endX, repeat: -1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(sprite, 600, { scaleX: 1.1, scaleY: 0.9, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    addRays()
    {
        this.makeRay("ray1", 120);
        this.makeRay("ray2", 230, 305);
        this.makeRay("ray3", 430, 320);
        this.makeRay("ray4", 520, 300);
        this.makeRay("ray5", 640, 300);
        this.makeRay("ray6", 720, 240);
    }

    makeRay(spriteName, startX, startY)
    {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this).setAlpha(0.4);
        ABCyaPhaser.Tweens.addTween(sprite, 1500, { alpha: 0.1, yoyo: true, repeat: -1, delay: Phaser.Math.Between(300, 1300) }, Phaser.Math.Easing.Linear);
    }

    oscillate(sprite)
    {
        ABCyaPhaser.Tweens.addTween(sprite, 1000, { scaleX: 1.02, scaleY: 0.98, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    float(sprite)
    {
        this.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x + 4, y: this.button.y }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y - 4 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x - 4, y: this.button.y }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y + 4 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y }, Phaser.Math.Easing.Linear),
                ],
            loop: true
        });
    }

    goClicked()
    {
        this.button.disableInteractive();

        this.addBubbles();

        this.time.delayedCall(1300, this.doTransition, null, this);
        this.time.delayedCall(2100, this.cleanUp, null, this);
    }

    addBubbles()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bubbles, this);

        this.emitter = new Emitter(this, 3);
        this.emitter.x = 0;
        this.emitter.y = this.scale.height + 10;

        this.add.existing(this.emitter);
        this.emitter.emitParticles("bubbles", 100);
    }

    doTransition()
    {
        ABCyaPhaser.Tweens.addTween(this.cameras.main, 800, { x: -1200 }, Phaser.Math.Easing.Linear);
    }

    cleanUp()
    {
        this.tweens.killAll();
        this.time.removeAllEvents();

        this.scene.start(Game.KEY);
    }

    handleTick()
    {
        this.box2d.update();
    }

    makeBubbleNumbers()
    {
        let level = gameData.CURRENT_LEVEL;
        this.limit = 6;

        this.startOffset = 0;
        if (level == 1)
        {
            this.limit = 6;
            this.startOffset = 0;
        }
        else if (level == 2)
        {
            this.limit = 6;
            this.startOffset = 6;
        }
        else if (level == 3)
        {
            this.limit = 7;
            this.startOffset = 12;
        }
        else if (level == 4)
        {
            this.limit = 7;
            this.startOffset = 19;
        }

        this.currentNumberToPop = this.startOffset;

        for (let i = 0; i < this.limit; i++)
        {
            let num = i + this.startOffset;

            let bubble = new PopBubble(this, num);
            bubble.x = Phaser.Math.Between(150, 800);
            bubble.y = Phaser.Math.Between(100, 500);
            bubble.clickAction = this.bubbleClicked.bind(this);

            this.box2d.createBody(bubble);

            this.add.existing(bubble);
            this.bubbles.push(bubble);
        }

        this.applyRandomForcesToBubbles();
        ABCyaPhaser.Timer.addRepeatingEvent(this, 500, this.applyRandomForcesToBubbles.bind(this), -1);
    }

    bubbleClicked(bubble)
    {
        bubble.pop(bubble.number + 1);
    }

    applyRandomForcesToBubbles()
    {
        for (let i = 0; i < this.bubbles.length; i++)
        {
            let bubble = this.bubbles[i];

            if (bubble)
            {
                //apply random forces for floating type look
                let xForce = Phaser.Math.Between(0, 400) - 200;
                let yForce = Phaser.Math.Between(0, 400) - 200;

                // shoot the ball
                bubble.body.ApplyImpulse(new Box2D.Common.Math.b2Vec2(xForce / SCALE, yForce / SCALE),
                    bubble.body.GetWorldCenter());
            }
        }
    }
}

const SCALE = 30;
const STEP = 20;
const TIMESTEP = 1 / STEP;